import React from "react";
import './layout.css';


const Layout = ({children}) => {
    return(
        <div className="layout">            
            <div className="navbar">
                <div className="brand">Vivace Manager 2023.001.00.LTS</div>                
            </div>
            <div className="container">
                {children}
            </div>
        </div>
    )

    // return (
    //     <div>
    //         <Navbar>
    //             <Container>
    //                 <Navbar.Brand>Vivace Manager</Navbar.Brand>                    
    //             </Container>
    //         </Navbar>
    //         {children}
    //     </div>
    //   );

    // return (
    //     <Nav
    //       activeKey="/home"
    //       onSelect={(selectedKey) => alert(`selected ${selectedKey}`)}
    //     >
    //       <Nav.Item>
    //         <Nav.Link>Vivace Manager</Nav.Link>
    //       </Nav.Item>
    //       <Nav.Item>
    //         <Nav.Link eventKey="link-1">Link</Nav.Link>
    //       </Nav.Item>
    //       <Nav.Item>
    //         <Nav.Link eventKey="link-2">Link</Nav.Link>
    //       </Nav.Item>
    //       <Nav.Item>
    //         <Nav.Link eventKey="disabled" disabled>
    //           Disabled
    //         </Nav.Link>
    //       </Nav.Item>
    //     </Nav>
    //   );
}

export default Layout;